import React from 'react';
import cls from 'classnames';

import { Pagination } from '@/components';
import { usePagination } from '@/hooks';

import styles from './RecentActivities.module.css';
import { useTranslation } from 'react-i18next';

// TODO: activity log nestjs api'den cekilmeli
interface ActivityItemProps {
  msg: string;
  createdAt: string;
}

function ActivityItem({
  msg = 'Lorem ipsum dolor sit amet, consectetur.',
  createdAt,
}: ActivityItemProps) {
  return (
    <li
      className={cls(
        'flex flex-col overflow-visible relative gap-y-2 ml-4 pb-8 pl-6 border-l border-blue-200 before:border-2 before:border-blue-500 before:bg-white first-of-type:before:bg-blue-500',
        styles['activity-item'],
      )}
    >
      <p className='text-base -mt-3 leading-6 font-medium text-gray-600'>{msg}</p>
      <time dateTime={createdAt} className='text-sm leading-5 font-normal text-gray-400'>
        {new Date(createdAt ?? 0).toLocaleString()}
      </time>
    </li>
  );
}

export default function RecentActivities() {
  const { t } = useTranslation();
  const { page, limit, setPage } = usePagination();
  // const { data, isLoading } = useGetApiV1AccountGetactivitylistQuery({ page, pageSize: limit });
  const data = {
    data: {
      list: [],
      totalPage: 0,
    },
  };

  const activities = React.useMemo(() => (data && data.data && data.data.list) || [], [data]);

  return (
    <div className='mx-auto w-full p-0 sm:p-8  lg:w-1/2 lg:border lg:rounded-3xl'>
      <h2
        className={cls('text-xl leading-7 font-medium text-center text-gray-900 block', {
          'mb-12': activities && activities.length > 0,
        })}
      >
        {t('Recent Activities')}
      </h2>

      <div className='content min-h-max'>
        <ul className='flex flex-col mx-auto items-start max-w-max'>
          {/* TODO {activities.map((activity, id) => (
              <ActivityItem key={id} {...activity} />
              ))} */}
        </ul>
      </div>

      {activities && activities.length > 0 && (
        <div className='hidden lg:block'>
          <Pagination
            page={page}
            limit={limit}
            setPage={setPage}
            totalPage={data?.data?.totalPage}
          />
        </div>
      )}
    </div>
  );
}
